import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../assets/userform.css';
import SideNavbar from './helpers/SideNavbar';
import defaultimage from "../assets/default-image.png";
import Swal from 'sweetalert2';
import { faEdit, faSave, faRefresh, faThumbsUp, faTrash, faSpinner, faEye, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import Select from 'react-select';
import { Modal, Button } from "react-bootstrap";

const UserForm = () => {
  const cleanValue = (key) => {
    const value = localStorage.getItem(key);
    return value === "null" || value === undefined || value === null ? "" : value;
  };

  const [isUpdating, setIsUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Loader state
  const [promptData, setPromptData] = useState([]); // Holds both new and existing prompts
  const [promptData1, setPromptData1] = useState([]); // Holds both new and existing prompts
  const [promptDatainterest, setPromptDatainterest] = useState([]); // Holds both new and existing prompts
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [goal, setGoal] = useState(localStorage.getItem("Goal") || '');
  const [prompts, setPrompts] = useState(Array.from({ length: 10 }, () => ({ text: '', isEditing: true })));
  const [generatingAnswer, setGeneratingAnswer] = useState(false);
  const [aiSuggestions, setAiSuggestions] = useState([]); // Renamed state
  // const [editingIndex, setEditingIndex] = useState(null);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [showSaveButton, setShowSaveButton] = useState(true);
  const UserID = localStorage.getItem("UserID");
  const [selectedHoliday, setSelectedHoliday] = useState('');
  const [holidayList, setHolidayList] = useState([]);
  const [selectedJobTitles, setSelectedJobTitles] = useState([]);
  const [selectedTargetAudience, setSelectedTargetAudience] = useState([]);
  const [countryCode, setCountryCode] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [countries, setCountries] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [targetAudienceList, setTargetAudienceList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // AccountType state - must be declared early
  const [accountType, setAccountType] = useState(localStorage.getItem('AccountType') || '');
  
  // Business fields state
  const [businessName, setBusinessName] = useState('');
  const [businessDescription, setBusinessDescription] = useState('');
  const [primaryServices, setPrimaryServices] = useState([]); // Changed to array for multi-select
  const [brandTone, setBrandTone] = useState(null);
  const [writingStyle, setWritingStyle] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState({ value: 'en', label: 'English' }); // Default to English


  useEffect(() => {
    const fetchHolidays = async () => {
      // Return early if countries list is not loaded
      if (countries.length === 0) return;

      // Derive selected country codes
      let selectedCountryCodes = [];

      if (Array.isArray(countryCode) && countryCode.length > 0) {
        selectedCountryCodes = countryCode.map(selected => {
          const match = countries.find(c => c.CountryName === selected.value);
          return match ? match.CountryCode : null;
        }).filter(Boolean);
      }

      // Default to 'US' if no valid country codes found
      if (selectedCountryCodes.length === 0) {
        selectedCountryCodes = ['US'];
      }

      try {
        const countryParam = selectedCountryCodes.join(',');
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/holidays?country=${countryParam}`);
        setHolidayList(response.data);
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };

    fetchHolidays();
  }, [countryCode, countries]);


  const getuserprofiledetails = () => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-profile-info`, { params: { UserID } })
      .then((response) => {
        const profile = response.data[0];
        console.log("API Response:", profile);

        // Check if profile has values for job titles, target audience, etc.
        if (profile) {
          setGoal(profile.Usergoal || "");

          // Update selectedJobTitles
          if (profile.JobTitle) {
            const jobTitlesList = profile.JobTitle.split(', ').map(title => ({
              label: title,
              value: title
            }));
            console.log("jobTitlesList", jobTitlesList)
            setSelectedJobTitles(jobTitlesList);
          }

          // Update selectedTargetAudience
          if (profile.TargetAudience) {
            const targetAudienceList = profile.TargetAudience.split(', ').map(audience => ({
              label: audience,
              value: audience
            }));
            setSelectedTargetAudience(targetAudienceList);
          }

          // Update selectedCountry
          if (profile.Country) {
            const countryList = profile.Country.split(', ').map(country => ({
              label: country,
              value: country
            }));
            setCountryCode(countryList);
          }

          // Update selectedIndustry
          if (profile.Industry) {
            const industryList = profile.Industry.split(', ').map(industry => ({
              label: industry,
              value: industry
            }));
            setSelectedIndustry(industryList);
          }

          // Update business fields
          setBusinessName(profile.BusinessName || '');
          setBusinessDescription(profile.BusinessDescription || '');
          
          // Convert PrimaryServices from comma-separated string to array of objects
          if (profile.PrimaryServices) {
            const servicesArray = profile.PrimaryServices.split(',').map(s => s.trim()).filter(s => s);
            const servicesOptions = servicesArray.map(service => {
              // Try to find matching option, otherwise create new option
              const existingOption = primaryServicesOptions.find(opt => opt.value === service || opt.label === service);
              return existingOption || { value: service, label: service };
            });
            setPrimaryServices(servicesOptions);
          } else {
            setPrimaryServices([]);
          }
          
          // Set brand tone and writing style if they exist
          if (profile.BrandTone) {
            setBrandTone({ label: profile.BrandTone, value: profile.BrandTone });
          }
          if (profile.WritingStyle) {
            setWritingStyle({ label: profile.WritingStyle, value: profile.WritingStyle });
          }
          
          // Set language preference (default to English if not set)
          console.log('🌐 Profile Language from API:', profile.Language);
          console.log('🌐 Available language options:', languageOptions);
          
          if (profile.Language) {
            const languageOption = languageOptions.find(opt => opt.value === profile.Language);
            console.log('🌐 Found language option:', languageOption);
            
            if (languageOption) {
              setSelectedLanguage(languageOption);
              console.log('✅ Language set to:', languageOption);
            } else {
              console.warn('⚠️ Language not found in options, using default English');
              setSelectedLanguage({ value: 'en', label: 'English' });
            }
          } else {
            console.log('⚠️ No language in profile, using default English');
            setSelectedLanguage({ value: 'en', label: 'English' });
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching profile info:', error);
      });
  };



  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/countries`);
      setCountries(response.data); // Make sure your backend returns an array of { name, date }
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };
  const fetchIndustries = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/industries`);
      setIndustries(response.data); // Make sure your backend returns an array of industries
    } catch (error) {
      console.error("Error fetching industries:", error);
    }
  };

  // Fetching Job Titles API
  const fetchJobTitles = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/jobtitles`);
      setJobTitles(response.data); // Make sure your backend returns an array of job titles
    } catch (error) {
      console.error("Error fetching job titles:", error);
    }
  };

  // Fetching Target Audience API
  const fetchTargetAudience = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/targetaudience`);
      setTargetAudienceList(response.data); // Make sure your backend returns an array of target audience options
    } catch (error) {
      console.error("Error fetching target audience:", error);
    }
  };

  const countryOptions = countries?.map(c => ({
    value: c.CountryCode,
    label: c.CountryName
  }));

  const industryOptions = industries?.map(i => ({
    value: i.IndustryID,
    label: i.IndustryName
  }));

  const jobTitleOptions = jobTitles?.map(j => ({
    value: j.JobTitleID,
    label: j.JobTitle
  }));

  const audienceOptions = targetAudienceList?.map(a => ({
    value: a.AudienceID,
    label: a.AudienceType
  }));

  // Primary Services / Products options (defined early so it can be used in useEffect)
  const primaryServicesOptions = [
    { value: 'Web Development', label: 'Web Development' },
    { value: 'Mobile App Development', label: 'Mobile App Development' },
    { value: 'Software Development', label: 'Software Development' },
    { value: 'SaaS Platform', label: 'SaaS Platform' },
    { value: 'Cloud Services', label: 'Cloud Services' },
    { value: 'IT Consulting', label: 'IT Consulting' },
    { value: 'Digital Marketing', label: 'Digital Marketing' },
    { value: 'Social Media Management', label: 'Social Media Management' },
    { value: 'Content Creation', label: 'Content Creation' },
    { value: 'SEO Services', label: 'SEO Services' },
    { value: 'E-commerce Solutions', label: 'E-commerce Solutions' },
    { value: 'Business Consulting', label: 'Business Consulting' },
    { value: 'Financial Services', label: 'Financial Services' },
    { value: 'Accounting Services', label: 'Accounting Services' },
    { value: 'Legal Services', label: 'Legal Services' },
    { value: 'HR Services', label: 'HR Services' },
    { value: 'Recruitment', label: 'Recruitment' },
    { value: 'Training & Education', label: 'Training & Education' },
    { value: 'Healthcare Services', label: 'Healthcare Services' },
    { value: 'Real Estate', label: 'Real Estate' },
    { value: 'Construction', label: 'Construction' },
    { value: 'Manufacturing', label: 'Manufacturing' },
    { value: 'Retail', label: 'Retail' },
    { value: 'Food & Beverage', label: 'Food & Beverage' },
    { value: 'Hospitality', label: 'Hospitality' },
    { value: 'Travel & Tourism', label: 'Travel & Tourism' },
    { value: 'Fitness & Wellness', label: 'Fitness & Wellness' },
    { value: 'Beauty & Cosmetics', label: 'Beauty & Cosmetics' },
    { value: 'Fashion & Apparel', label: 'Fashion & Apparel' },
    { value: 'Automotive', label: 'Automotive' },
    { value: 'Energy & Utilities', label: 'Energy & Utilities' },
    { value: 'Telecommunications', label: 'Telecommunications' },
    { value: 'Media & Entertainment', label: 'Media & Entertainment' },
    { value: 'Gaming', label: 'Gaming' },
    { value: 'Non-Profit', label: 'Non-Profit' },
    { value: 'Daily Pooja', label: 'Daily Pooja' },
    { value: 'Abhishekam', label: 'Abhishekam' },
    { value: 'Festivals', label: 'Festivals' },
    { value: 'Religious Ceremonies', label: 'Religious Ceremonies' },
    { value: 'Spiritual Guidance', label: 'Spiritual Guidance' },
    { value: 'Temple Visits', label: 'Temple Visits' },
    { value: 'Devotional Programs', label: 'Devotional Programs' },
    { value: 'Special Poojas', label: 'Special Poojas' },
    { value: 'Religious Education', label: 'Religious Education' },
    { value: 'Prasadam Distribution', label: 'Prasadam Distribution' },
    { value: 'Religious Counseling', label: 'Religious Counseling' },
    { value: 'Other', label: 'Other' }
  ].sort((a, b) => a.label.localeCompare(b.label));

  // Brand tone options
  const brandToneOptions = [
    { value: 'Professional', label: 'Professional' },
    { value: 'Friendly', label: 'Friendly' },
    { value: 'Casual', label: 'Casual' },
    { value: 'Formal', label: 'Formal' },
    { value: 'Humorous', label: 'Humorous' },
    { value: 'Inspirational', label: 'Inspirational' },
    { value: 'Authoritative', label: 'Authoritative' },
    { value: 'Conversational', label: 'Conversational' },
    { value: 'Spiritual', label: 'Spiritual' },
    { value: 'Devotional', label: 'Devotional' },
    { value: 'Reverent', label: 'Reverent' },
    { value: 'Traditional', label: 'Traditional' },
    { value: 'Sacred', label: 'Sacred' }
  ];

  // Writing style options
  // Language options for AI content generation
  const languageOptions = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'fr', label: 'French' },
    { value: 'de', label: 'German' },
    { value: 'it', label: 'Italian' },
    { value: 'pt', label: 'Portuguese' },
    { value: 'ru', label: 'Russian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'ko', label: 'Korean' },
    { value: 'zh', label: 'Chinese' },
    { value: 'hi', label: 'Hindi' },
    { value: 'te', label: 'Telugu' },
    { value: 'ar', label: 'Arabic' },
    { value: 'nl', label: 'Dutch' },
    { value: 'pl', label: 'Polish' },
    { value: 'tr', label: 'Turkish' },
    { value: 'sv', label: 'Swedish' },
    { value: 'da', label: 'Danish' },
    { value: 'no', label: 'Norwegian' },
    { value: 'fi', label: 'Finnish' },
    { value: 'cs', label: 'Czech' },
    { value: 'th', label: 'Thai' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'id', label: 'Indonesian' },
    { value: 'ms', label: 'Malay' },
    { value: 'he', label: 'Hebrew' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'ro', label: 'Romanian' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'el', label: 'Greek' },
    { value: 'bg', label: 'Bulgarian' }
  ];

  const writingStyleOptions = [
    { value: 'Short & Punchy', label: 'Short & Punchy' },
    { value: 'Detailed & Informative', label: 'Detailed & Informative' },
    { value: 'Storytelling', label: 'Storytelling' },
    { value: 'Question-Based', label: 'Question-Based' },
    { value: 'List-Based', label: 'List-Based' },
    { value: 'Educational', label: 'Educational' },
    { value: 'News-Style', label: 'News-Style' },
    { value: 'Personal Anecdote', label: 'Personal Anecdote' },
    { value: 'Devotional', label: 'Devotional' },
    { value: 'Traditional', label: 'Traditional' },
    { value: 'Sacred', label: 'Sacred' },
    { value: 'Reverent', label: 'Reverent' }
  ];

  // Fetch all data when the component is mounted and when AccountType changes
  useEffect(() => {
    fetchCountries();
    fetchIndustries();
    fetchJobTitles();
    fetchTargetAudience();
    getuserprofiledetails();
  }, [accountType]); // Re-fetch when AccountType changes


  const RoleID = localStorage.getItem("RoleID")
  const Token = localStorage.getItem('AccessToken');
  console.log("Token", Token)
  const navigate = useNavigate();
 
  // Prevent accessing User Preferences for PAGE accounts if no social media accounts are connected.
  // For PERSONAL accounts, show a gentle reminder to login with LinkedIn if not connected.
  useEffect(() => {
    const checkSocialAccounts = async () => {
      try {
        const storedAccountType = localStorage.getItem('AccountType');
        if (!UserID || !storedAccountType) return;

        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
        const url = `${API_BASE_URL}/api/GetAllSocialMediaAccounts/${UserID}`;
        const response = await axios.get(url);
        const accounts = response.data || [];

        if (storedAccountType === 'Page') {
          // PAGE: require at least one social account
          if (!accounts || accounts.length === 0) {
            const result = await Swal.fire({
              icon: 'warning',
              title: 'Connect a social account first',
              text: 'Please connect at least one social media account (LinkedIn, Facebook, or Instagram) before setting your User Preferences.',
              confirmButtonText: 'OK',
              confirmButtonColor: '#2e3192',
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            if (result.isConfirmed) {
              // Read RoleID fresh from localStorage inside the effect
              const currentRoleID = localStorage.getItem("RoleID");
              const roleIdNum = currentRoleID ? parseInt(currentRoleID, 10) : null;
              
              console.log('Navigating with RoleID:', roleIdNum);
              
              // Navigate to the correct home based on role
              if (roleIdNum === 1) {
                navigate('/home');
              } else if (roleIdNum === 4) {
                navigate('/Pagehome');
              } else if (roleIdNum === 2) {
                navigate('/adminhome');
              } else {
                console.warn('Unknown RoleID:', roleIdNum, '- Navigation skipped');
              }
            }
          }
        } else {
          // NON-PAGE (e.g. User/Personal): remind to login with LinkedIn if not connected and navigate back to their home on OK
          const hasLinkedIn = accounts && accounts.some(acc => acc.PlatformId === 1);
          if (!hasLinkedIn) {
            const result = await Swal.fire({
              icon: 'info',
              title: 'Login with LinkedIn',
              text: 'For best results, please login with LinkedIn so we can personalize your content.',
              confirmButtonText: 'OK',
              confirmButtonColor: '#2e3192',
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            if (result.isConfirmed) {
              // Read RoleID fresh from localStorage inside the effect
              const currentRoleID = localStorage.getItem("RoleID");
              const roleIdNum = currentRoleID ? parseInt(currentRoleID, 10) : null;
              
              console.log('Navigating with RoleID:', roleIdNum);
              
              // Navigate to the correct home based on role
              if (roleIdNum === 1) {
                navigate('/home');
              } else if (roleIdNum === 4) {
                navigate('/Pagehome');
              } else if (roleIdNum === 2) {
                navigate('/adminhome');
              } else {
                console.warn('Unknown RoleID:', roleIdNum, '- Navigation skipped');
              }
            }
          }
        }
      } catch (error) {
        console.error('Error checking social media accounts before opening User Preferences:', error);
      }
    };

    checkSocialAccounts();
  }, [UserID, navigate]);

  // Watch for AccountType changes in localStorage (for admin user selection)
  useEffect(() => {
    const handleStorageChange = () => {
      const newAccountType = localStorage.getItem('AccountType');
      if (newAccountType !== accountType) {
        setAccountType(newAccountType || '');
      }
    };

    // Check on mount and when component is focused
    handleStorageChange();
    
    // Listen for storage events (when localStorage changes in other tabs/windows)
    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically for changes (for same-tab updates)
    const interval = setInterval(handleStorageChange, 500);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [accountType]);
  let profileDet;


  if (RoleID == 1 && Token != null) {
    const loginname = JSON.parse(localStorage.getItem("userProfile"));
    profileDet = loginname[0];
  } else if (Token === null) {
    if (RoleID == 1 || RoleID == 4) {
      RoleID == 1 ? navigate("/home") : navigate("/Pagehome");
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Login with LinkedIn First to proceed!',
        showConfirmButton: false,
        timer: 2000
      });
    } else if (RoleID == 2) {
      navigate("/Adminhome");
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Please select user from dropdown before proceeding!',
        showConfirmButton: true
      });
    }
  }


  const handleGoalChange = (e) => {
    const newGoal = e.target.value;
    setGoal(e.target.value);
  };

  const handleSaveGoal = () => {
    setIsLoading(true);
    // generatePrompts(); // Generate prompts after saving the goal
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'AI Generated Prompts saved successfully!',
      showConfirmButton: false,
      timer: 2000
    }).then(() => {
      // After the Swal alert completes, fetch suggestions
      fetchAISuggestions().then(() => {
        // Then open the accordion
        const aiAccordionBtn = document.getElementById('aiAccordionButton');
        if (aiAccordionBtn && aiAccordionBtn.classList.contains('collapsed')) {
          aiAccordionBtn.click();
        }
      });
    });
  };

  const holidayOptions = holidayList
    .filter(holiday => moment.utc(holiday.Date).isSameOrAfter(moment.utc(), 'day')) // Compare in UTC
    .map(holiday => ({
      value: holiday.Name,
      label: `${holiday.Name} (${moment.utc(holiday.Date).format("MMM DD, YYYY")})`
    }));


  const handleModal = (selectedOption) => {
    if (!selectedOption) return;
    setSelectedHoliday(selectedOption.value); // selectedOption is { value, label }
    setIsModalOpen(true);
  };

  const handleHolidayChange = async () => {
    console.log("Called", selectedHoliday)

    const accessToken = localStorage.getItem('AccessToken');
    const tokenID = localStorage.getItem('Tokenid');
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const AccountType = localStorage.getItem('AccountType');
    const SelectedUserEmail = localStorage.getItem('UserEmail');
    const SelectedUserEmail1 = localStorage.getItem('Email');
    const SelectedUserAccountId = localStorage.getItem('SelectedUserAccountId');
    const AccountId = userProfile ? userProfile[0]?.AccountId : null;
    console.log("274", AccountId)
    const LinkedinEmail = RoleID === 2 ? SelectedUserEmail1 : SelectedUserEmail;

    const holiday = holidayList.find(h => h.Name == selectedHoliday);
    if (!holiday) return;

    const promptText = `Generate/Draft a creative ${selectedHoliday} message`;
    const postDate = holiday.Date;

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/saveexceptionprompts`, {
        UserID,
        ExceptionPromptData: promptText
      });

      const newPromptId = response.data.ExceptionPromptID;

      setPromptData1(prev => [
        { id: newPromptId, text: promptText, isEditing: false },
        ...prev
      ]);

      Swal.fire({
        icon: 'success',
        title: 'Prompt saved and scheduled post successfully!',
        timer: 1500,
        showConfirmButton: false
      });

      const dayOfWeekGMT = moment.tz(postDate, "Etc/GMT").format("dddd");

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/schedule-post`, {
        Days: dayOfWeekGMT,
        ScheduleTime: "09:00",
        StartDate: postDate,
        EndDate: postDate,
        Prompt: newPromptId,
        AccessToken: accessToken,
        Tokenid: tokenID,
        TimeZone: "Etc/GMT",
        Email: LinkedinEmail,
        AccountId: RoleID == 1 || RoleID == 4 ? AccountId : SelectedUserAccountId,
        UserID: UserID,
        Status: 'PENDING',
        PromptType: 2,
        AccountType: AccountType
      });

    } catch (err) {
      console.error("Error saving prompt or scheduling post", err);
      Swal.fire({
        icon: 'error',
        title: 'Error saving prompt or scheduling post',
        timer: 2000,
        showConfirmButton: false
      });
    }

    setSelectedHoliday(null);
    setIsModalOpen(false);
  };

  const generatePrompts = async () => {
    setIsLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generate-prompts`, {
        goal, UserID
      });

      const newPrompts = response.data.prompts;

      setPrompts(newPrompts);
      await savePrompts(newPrompts); // Your existing DB save function
    } catch (error) {
      console.error('Frontend error:', error);
      setPrompts([{ text: 'Sorry, something went wrong. Please try again!', isEditing: false }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handlesaveJobTitleandTarget = async () => {
    setIsLoading(true);

    // Validate that all required fields are filled
    const missingFields = [];
    
    if (!selectedJobTitles || selectedJobTitles.length === 0) {
      missingFields.push('Job Title');
    }
    if (!selectedTargetAudience || selectedTargetAudience.length === 0) {
      missingFields.push('Target Audience');
    }
    if (!countryCode || countryCode.length === 0) {
      missingFields.push('Country');
    }
    if (!selectedIndustry || selectedIndustry.length === 0) {
      missingFields.push('Industry');
    }
    if (!goal || goal.trim() === '') {
      missingFields.push('Primary Goal');
    }
    
    // Business fields are only required for Page AccountType
    if (accountType === 'Page') {
      if (!businessName || businessName.trim() === '') {
        missingFields.push('Business Name');
      }
      if (!businessDescription || businessDescription.trim() === '') {
        missingFields.push('Business Description');
      }
    }

    // If any required fields are missing, show error and return
    if (missingFields.length > 0) {
      setIsLoading(false);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Required Fields Missing',
        html: `Please fill in all required fields before saving:<br/><br/>
               <strong>Missing fields:</strong><br/>
               ${missingFields.map(field => `• ${field}`).join('<br/>')}`,
        showConfirmButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor: '#2e3192',
        showCancelButton: false
      });
      return;
    }

    // Convert job titles, target audience, country, and industry IDs to strings
    const sanitize = (value) => {
      return value === "" || value === "null" || value === undefined || value === null ? null : value;
    };

    // Check if the selected arrays have valid values before joining them
    const selectedJobTitlesString = selectedJobTitles.length > 0
      ? selectedJobTitles
        .map(job => job.label)  // Use job.label to get the actual job title
        .join(', ')
      : null;  // If no job titles are selected, return null

    const selectedTargetAudienceString = selectedTargetAudience.length > 0
      ? selectedTargetAudience
        .map(audience => audience.label)  // Use audience.label to get the actual target audience
        .join(', ')
      : null;  // If no target audience is selected, return null

    const selectedCountryString = countryCode.length > 0
      ? countryCode
        .map(country => country.label)  // Use country.label to get the actual country name
        .join(', ')
      : null;  // If no country is selected, return null

    const selectedIndustryString = selectedIndustry.length > 0
      ? selectedIndustry
        .map(industry => industry.label)  // Use industry.label to get the actual industry name
        .join(', ')
      : null;  // If no industry is selected, return null

    // Log the strings to verify what we're sending
    console.log("Selected Job Titles String:", selectedJobTitlesString);
    console.log("Selected Target Audience String:", selectedTargetAudienceString);
    console.log("Selected Country String:", selectedCountryString);
    console.log("Selected Industry String:", selectedIndustryString);

    // Convert primaryServices array to comma-separated string
    const primaryServicesString = Array.isArray(primaryServices) && primaryServices.length > 0
      ? primaryServices.map(s => s.label || s.value || s).join(', ')
      : (primaryServices || null);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/updateuserprofiledetails`, {
        UserID,
        jobTitle: sanitize(selectedJobTitlesString),
        targetaudience: sanitize(selectedTargetAudienceString),
        country: sanitize(selectedCountryString),
        industry: sanitize(selectedIndustryString),
        goal: sanitize(goal),
        businessName: sanitize(businessName),
        businessDescription: sanitize(businessDescription),
        primaryServices: sanitize(primaryServicesString),
        brandTone: sanitize(brandTone?.value || brandTone),
        writingStyle: sanitize(writingStyle?.value || writingStyle),
        language: sanitize(selectedLanguage?.value || 'en')
      });

      if (response.data.message === "User profile updated successfully") {
        // Update localStorage with saved profile data
        const currentUserProfile = JSON.parse(localStorage.getItem("userProfile")) || [];
        const updatedProfile = currentUserProfile[0] ? { ...currentUserProfile[0] } : {};
        
        // Update profile fields in localStorage
        updatedProfile.JobTitle = selectedJobTitlesString || updatedProfile.JobTitle || null;
        updatedProfile.TargetAudience = selectedTargetAudienceString || updatedProfile.TargetAudience || null;
        updatedProfile.Country = selectedCountryString || updatedProfile.Country || null;
        updatedProfile.Industry = selectedIndustryString || updatedProfile.Industry || null;
        updatedProfile.Usergoal = goal || updatedProfile.Usergoal || null;
        updatedProfile.BusinessName = businessName || updatedProfile.BusinessName || null;
        updatedProfile.BusinessDescription = businessDescription || updatedProfile.BusinessDescription || null;
        updatedProfile.PrimaryServices = primaryServicesString || updatedProfile.PrimaryServices || null;
        updatedProfile.BrandTone = brandTone?.value || brandTone || updatedProfile.BrandTone || null;
        updatedProfile.WritingStyle = writingStyle?.value || writingStyle || updatedProfile.WritingStyle || null;
        updatedProfile.Language = selectedLanguage?.value || 'en';
        
        // Save updated profile to localStorage
        localStorage.setItem("userProfile", JSON.stringify([updatedProfile]));
        
        // Generate 5 prompts based on user preferences
        const jobTitlesText = selectedJobTitlesString || 'professionals';
        const audienceText = selectedTargetAudienceString || 'your audience';
        const countriesText = selectedCountryString || 'your region';
        const industryText = selectedIndustryString || 'your industry';
        const goalText = goal && goal.trim().length > 0 ? goal.trim() : 'growth and engagement';

        const generatedPrompts = [
          `Share a quick tip for ${jobTitlesText} in ${industryText} to achieve ${goalText}.`,
          `Ask a question to ${audienceText} about a common challenge in ${industryText}.`,
          `Post a short story of a win related to ${goalText} from ${countriesText}.`,
          `Create a checklist: 5 steps ${jobTitlesText} can take this week toward ${goalText}.`,
          `Recommend a tool or resource helping ${audienceText} with ${goalText} in ${industryText}.`
        ].map(text => ({ id: null, text, isEditing: false }));

        // Save the generated prompts to database
        try {
          for (const prompt of generatedPrompts) {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/saveprompts`, {
              UserID,
              PromptData: prompt.text,
              PromptID: null
            });
          }
          
          // Refresh prompts from database to get the correct IDs
          await fetchData();

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Profile saved and 5 prompts generated!',
            showConfirmButton: false,
            timer: 2000
          });
        } catch (promptError) {
          console.error('Error saving prompts:', promptError);
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Profile saved successfully!',
            showConfirmButton: false,
            timer: 2000
          });
        }
      }

      getuserprofiledetails();  // Fetch updated profile details
      setIsLoading(false);
    } catch (error) {
      console.error('Frontend error:', error);
      setIsLoading(false);
    }
  };


  const savePrompts = async (generatedPrompts) => {
    setIsLoading(true); // Start spinner before saving prompts
    const UserID = localStorage.getItem("UserID");
    const AIPrompts = generatedPrompts.filter(prompt => prompt.text.trim() !== '');

    if (!UserID || AIPrompts.length === 0) {
      console.error('UserID and non-empty AIPrompts are required');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/saveAISuggestions`, {
        UserID,
        AIPrompts: AIPrompts.map(prompt => prompt.text),
        goal
      });
      console.log('Prompts saved successfully:', response.data);
      handleSaveGoal();
    } catch (error) {
      console.error('Error saving prompts:', error);
    }
    finally {
      setIsLoading(false); // Ensure spinner stops after save
    }
  };



  useEffect(() => {
    fetchAISuggestions();
  }, []);

  const fetchAISuggestions = async () => {
    const userID = localStorage.getItem('UserID'); // Assuming UserID is stored in localStorage
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getAISuggestions/${userID}`);
      setAiSuggestions(response.data);
      console.log("111", response.data)
    } catch (error) {
      console.error('Error fetching AI suggestions:', error);
    }
  };

  const fetchSuggestions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/suggestions`);
      // Assuming response.data is an array of suggestion objects
      setAiSuggestions(response.data); // Each suggestion should have an 'id' property
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  };


  // Edit button handler
  const handleEdit1 = (index) => {
    setEditingIndex(index);
    setShowSaveButton(false);

  };

  // Save button handler
  const handleSave1 = async (index) => {
    const updatedSuggestion = aiSuggestions[index];

    if (!updatedSuggestion || !updatedSuggestion.PromptID) {
      console.error('Invalid suggestion or ID is undefined.');
      return;
    }

    try {

      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/suggestions/${parseInt(updatedSuggestion.PromptID)}`, {
        AIPromptData: updatedSuggestion.AIPromptData,
        AISuggestion: updatedSuggestion.AISuggestion // Ensure this is included
      });
      setEditingIndex(-1); // Exit edit mode
      // Show success alert after saving the edited prompt
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Prompt updated successfully!',
        showConfirmButton: false,
        timer: 2000
      });
      setShowSaveButton(true);
    } catch (error) {
      console.error('Error saving suggestion:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error saving the prompt.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };


  const handleSaveToPromptTable = async (index) => {
    const promptToSave = aiSuggestions[index];
    const { UserID, AIPromptData, PromptID } = promptToSave; // Use PromptID for deletion

    try {
      // Step 1: Save prompt to Prompt table
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/saveprompts`, {
        UserID: UserID,
        PromptData: AIPromptData,
        PromptID: null
      });

      console.log('Successfully saved to Prompt table:', response.data);

      // Show success alert after saving to the prompt table
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Prompt saved to Saved Prompts successfully!',
        showConfirmButton: false,
        timer: 2000
      }).then(() => {
        // Open "Saved Prompts" accordion
        const savedAccordionBtn = document.getElementById('savedPromptsAccordionButton');
        if (savedAccordionBtn && savedAccordionBtn.classList.contains('collapsed')) {
          savedAccordionBtn.click();
          savedAccordionBtn.scrollIntoView({ behavior: 'smooth' });
        }
      });
      fetchData();

      // Step 2: Delete the prompt from AISuggestionPrompt table if saved successfully
      if (PromptID) {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/deletesuggestionprompt/${PromptID}`);
        console.log('Successfully deleted from AISuggestionPrompt table:', PromptID);

        // Step 3: Update the frontend state
        const updatedSuggestions = aiSuggestions.filter((_, i) => i !== index);
        setAiSuggestions(updatedSuggestions);
      }
    } catch (error) {
      console.error('Error processing prompt save or delete:', error);
      // Optionally: Handle error (show notification or message to user)
    }
  };




  const handleDelete1 = async (index) => {
    const promptToDelete = aiSuggestions[index]; // Use aiSuggestions array

    if (promptToDelete && promptToDelete.PromptID) { // Use PromptID from promptToDelete
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/deletesuggestionprompt/${promptToDelete.PromptID}`;
        await axios.delete(url);

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Prompt deleted successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        // Remove the prompt from the UI
        const updatedSuggestions = aiSuggestions.filter((_, i) => i !== index);
        setAiSuggestions(updatedSuggestions); // Update state for UI
      } catch (error) {
        console.error('Error deleting prompt:', error);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'An error occurred while deleting the prompt.',
          showConfirmButton: false,
          timer: 3000
        });
      }
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Cannot delete a new prompt. Please save it first.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  const fetchData = async () => {
    setIsLoading(true); // Start by setting loading to true
    if (UserID) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getprompts/${UserID}`);
        if (response.status === 200 && response.data) {
          const data = response.data;
          if (data.length > 0) {
            setPromptData(data.map(prompt => ({
              id: prompt.PromptID,
              text: prompt.PromptData,
            })));

          } else {
            setPromptData([{ id: null, text: '' }]);
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false); // Ensure loading is set to false after fetching
      }
    }
  };

  // Fetch existing prompts when the component loads
  useEffect(() => {
    fetchData();
  }, [UserID]);
  const handleEdit = (index) => {
    const updatedPrompts = [...promptData];
    updatedPrompts[index].isEditing = true; // Set the prompt to be editable
    setPromptData(updatedPrompts);

    console.log('Editing prompt:', updatedPrompts[index]); // Check the prompt details, including the ID

  };
  const handleSave = async (index) => {
    const prompt = promptData[index];
    setLoadingSubmit(true);

    if (!UserID) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'UserID is missing.',
        showConfirmButton: false,
        timer: 3000
      });
      setLoadingSubmit(false);
      return;
    }

    try {
      const url = prompt.id
        ? `${process.env.REACT_APP_API_BASE_URL}/api/updateprompt` // For existing prompts
        : `${process.env.REACT_APP_API_BASE_URL}/api/saveprompts`; // For new prompts

      const formData = {
        PromptID: prompt.id,
        PromptData: prompt.text,
        UserID: prompt.id ? undefined : UserID // Only include UserID if it's a new prompt
      };

      console.log('Form Data being sent:', formData); // Log for debugging


      if (prompt.id) {
        // Update existing prompt
        await axios.put(url, formData);

      } else {
        // Create new prompt
        const response = await axios.post(url, formData);
        // Update the promptData with the new ID from the response
        const newPromptId = response.data.PromptID; // Adjust based on your backend response structure
        const updatedPrompts = [...promptData];
        updatedPrompts[index].id = newPromptId; // Assign the new ID
        setPromptData(updatedPrompts);
      }

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Prompt saved successfully!',
        showConfirmButton: false,
        timer: 3000
      });

      // Reset to not editable after saving
      const updatedPrompts = [...promptData];
      updatedPrompts[index].isEditing = false;
      setPromptData(updatedPrompts);
    } catch (error) {
      console.error('Error saving prompt:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred while saving the prompt.',
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setLoadingSubmit(false);
    }
  };
  const handleDelete = async (index) => {
    const prompt = promptData[index];

    if (prompt.id) {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/deleteprompt/${prompt.id}`;
        await axios.delete(url);

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Prompt deleted successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        // Remove the prompt from the UI
        const updatedPrompts = promptData.filter((_, i) => i !== index);
        setPromptData(updatedPrompts);
      } catch (error) {
        console.error('Error deleting promp:', error.status);
         if (error.status===400 && error.response.data) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.response.data.error || 'An error occurred while deleting the prompt.',
            showConfirmButton: false,
            timer: 10000
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'An error occurred while deleting the prompt.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      }
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Cannot delete a new prompt. Please save it first.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };
  const addPromptField = () => {
    setPromptData([{ id: null, text: '', isEditing: true }, ...promptData]);
  };
  const handlePromptChange = (index, value) => {
    const updatedPrompts = [...promptData];
    updatedPrompts[index].text = value;
    setPromptData(updatedPrompts);
  };
  useEffect(() => {
    const fetchExceptionData = async () => {
      setIsLoading(true);
      if (UserID) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getexceptionprompts/${UserID}`);
          if (response.status === 200 && response.data) {
            const data = response.data.map(prompt => ({
              id: prompt.ExceptionPromptID, // Ensure this is mapped correctly
              text: prompt.ExceptionPromptData,
              isEditing: false, // Initialize the editing state
            }));
            setPromptData1(data);
            console.log('Mapped Data:', data); // Log to confirm the mapping
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchExceptionData();
  }, [UserID]);

  useEffect(() => {
    const fetchInterestData = async () => {
      setIsLoading(true);
      if (UserID) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getInterestsprompts/${UserID}`);
          if (response.status === 200 && response.data) {
            const data = response.data.map(prompt => ({
              id: prompt.InterestsPromptID, // Ensure this is mapped correctly
              text: prompt.InterestsPromptData,
              isEditing: false, // Initialize the editing state
            }));
            setPromptDatainterest(data);
            console.log('Mapped Data:', data); // Log to confirm the mapping
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchInterestData();
  }, [UserID]);

  const handleExceptionalEdit = (index) => {
    const updatedPrompts = [...promptData1];
    updatedPrompts[index].isEditing = true; // Mark the prompt as being edited
    setPromptData1(updatedPrompts);

    console.log('Editing prompt:', updatedPrompts[index]); // This should show the correct ID
  };
  const handleExceptionalDelete = async (index) => {
    const prompt = promptData1[index];

    if (prompt.id) {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/deleteExceptionprompt/${prompt.id}`;
        await axios.delete(url);

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Prompt deleted successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        // Remove the prompt from the UI
        const updatedPrompts = promptData1.filter((_, i) => i !== index);
        setPromptData1(updatedPrompts);
      } catch (error) {
        console.error('Error deleting prompt:', error);
        if (error.status===400 && error.response.data) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.response.data.error || 'An error occurred while deleting the prompt.',
            showConfirmButton: false,
            timer: 10000
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'An error occurred while deleting the prompt.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      }
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Cannot delete a new prompt. Please save it first.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };
  const addExceptionalPromptField = () => {
    setPromptData1([{ id: null, text: '', isEditing: true }, ...promptData1]);
  };
  const handleExceptionalPromptChange = (index, value) => {
    const updatedPrompts = [...promptData1];
    updatedPrompts[index].text = value; // Ensure the text is set correctly
    setPromptData1(updatedPrompts);
  };
  const handleExceptionalSave = async (index) => {
    const prompt = promptData1[index];
    console.log('Saving prompt:', prompt); // Check the prompt details

    setLoadingSubmit(true);
    if (!UserID) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'UserID is missing.',
        showConfirmButton: false,
        timer: 3000
      });
      setLoadingSubmit(false);
      return;
    }
    try {
      const url = prompt.id
        ? `${process.env.REACT_APP_API_BASE_URL}/api/updateexceptionprompt`
        : `${process.env.REACT_APP_API_BASE_URL}/api/saveexceptionprompts`;
      // Prepare form data based on whether it's an update or save
      const formData = {
        ExceptionPromptID: prompt.id || undefined, // Include ID only for existing prompts
        ExceptionPromptData: prompt.text,
        UserID: prompt.id ? undefined : UserID // Only include UserID if it's a new prompt
      };
      console.log('Form Data being sent:', formData); // Log for debugging
      if (prompt.id) {
        // Update existing prompt
        await axios.put(url, formData);
      } else {
        // Create new prompt
        const response = await axios.post(url, formData);
        const newPromptId = response.data.ExceptionPromptID;
        const updatedPrompts = [...promptData1];
        updatedPrompts[index].id = newPromptId; // Assign the new ID
        setPromptData1(updatedPrompts);
      }
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Prompt saved successfully!',
        showConfirmButton: false,
        timer: 3000
      });
      // Reset to not editable after saving
      const updatedPrompts = [...promptData1];
      updatedPrompts[index].isEditing = false; // Set isEditing to false after saving
      setPromptData1(updatedPrompts);
    } catch (error) {
      console.error('Error saving prompt:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred while saving the prompt.',
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleInterestEdit = (index) => {
    const updatedPrompts = [...promptDatainterest];
    updatedPrompts[index].isEditing = true; // Mark the prompt as being edited
    setPromptDatainterest(updatedPrompts);

    console.log('Editing prompt:', updatedPrompts[index]); // This should show the correct ID
  };
  const handleInterestDelete = async (index) => {
    const prompt = promptDatainterest[index];

    if (prompt.id) {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/deleteInterestsprompt/${prompt.id}`;
        await axios.delete(url);

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Feed Interests deleted successfully!',
          showConfirmButton: false,
          timer: 3000
        });

        // Remove the prompt from the UI
        const updatedPrompts = promptDatainterest.filter((_, i) => i !== index);
        setPromptDatainterest(updatedPrompts);
      } catch (error) {
        console.error('Error deleting Feed Interests:', error);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'An error occurred while deleting the Feed Interests.',
          showConfirmButton: false,
          timer: 3000
        });
      }
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Cannot delete a new Feed Interests. Please save it first.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };
  const addInterestPromptField = () => {
    setPromptDatainterest([...promptDatainterest, { id: null, text: '', isEditing: true }]);
  };
  const handleInterestPromptChange = (index, value) => {
    const updatedPrompts = [...promptDatainterest];
    updatedPrompts[index].text = value; // Ensure the text is set correctly
    setPromptDatainterest(updatedPrompts);
  };
  const handleInterestSave = async (index) => {
    const prompt = promptDatainterest[index];
    console.log('Saving prompt:', prompt); // Check the prompt details

    setLoadingSubmit(true);
    if (!UserID) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'UserID is missing.',
        showConfirmButton: false,
        timer: 3000
      });
      setLoadingSubmit(false);
      return;
    }
    try {
      const url = prompt.id
        ? `${process.env.REACT_APP_API_BASE_URL}/api/updateinteretsprompts`
        : `${process.env.REACT_APP_API_BASE_URL}/api/saveinteretsprompts`;
      // Prepare form data based on whether it's an update or save
      const formData = {
        InterestsPromptID: prompt.id || undefined, // Include ID only for existing prompts
        InterestsPromptData: prompt.text,
        UserID: prompt.id ? undefined : UserID // Only include UserID if it's a new prompt
      };
      console.log('Form Data being sent:', formData); // Log for debugging
      if (prompt.id) {
        // Update existing prompt
        await axios.put(url, formData);
      } else {
        // Create new prompt
        const response = await axios.post(url, formData);
        const newPromptId = response.data.InterestsPromptID;
        const updatedPrompts = [...promptDatainterest];
        updatedPrompts[index].id = newPromptId; // Assign the new ID
        setPromptDatainterest(updatedPrompts);
      }
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Feed Interests saved successfully!',
        showConfirmButton: false,
        timer: 3000
      });
      // Reset to not editable after saving
      const updatedPrompts = [...promptDatainterest];
      updatedPrompts[index].isEditing = false; // Set isEditing to false after saving
      setPromptDatainterest(updatedPrompts);
    } catch (error) {
      console.error('Error saving Feed Interests:', error);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'An error occurred while saving the Feed Interests.',
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setLoadingSubmit(false);
    }
  };





  return (

    <SideNavbar>
      <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
        <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
          <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>Profile Hub</h5>
        </div>
        <hr />
        {isLoading ? (
          <div className='spinner'></div>
        ) : (
          <div className="container mt-4 pb-5">
            <div className="row">
              {RoleID == 1 && <div className="accordion accordion-flush" id="accordionFlushExample">
                <div className="accordion-item">
                  <div className="accordion-header shadow-sm" id="flush-headingOne">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                      <h5>User Details</h5>
                    </button>
                  </div>
                  <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                      <form className="user-form">
                        <><div className='circle-image me-2' style={{ height: 100, width: 100 }}>
                          {profileDet?.ProfileUrl ? <img src={profileDet?.ProfileUrl} alt="Profile" /> : <img src={defaultimage} alt="Default" />}
                        </div><div className="form-row mt-5">
                            <div className="form-group">
                              <input
                                placeholder='First Name'
                                type="text"
                                value={profileDet?.FirstName} />
                            </div>
                            <div className="form-group">
                              <input
                                placeholder='Last Name'
                                type="text"
                                value={profileDet?.LastName} />
                            </div>
                          </div><div className="form-row">
                            <div className="form-group">
                              <input
                                placeholder='Email'
                                type="email"
                                value={profileDet?.Email} />
                            </div>
                            <div className="form-group">
                              <input
                                placeholder='Full Name'
                                type="text"
                                value={profileDet?.FullName} />
                            </div>
                          </div></>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              }

              <div className="accordion accordion-flush mt-3" id="accordionFlushExample9">
                <div className="accordion-item">
                  <div className="accordion-header  shadow-sm" id="flush-headingInterests">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseNine"
                      aria-expanded="false"
                      aria-controls="flush-collapseNine"
                    >
                      <h5>User Preferences</h5>
                    </button>
                  </div>
                  <div
                    id="flush-collapseNine"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingNine"
                    data-bs-parent="#accordionFlushExample9"
                  >
                    <div className="accordion-body">
                      <div className="form-row">

                        <div className="form-group">
                          <label>Job Titles <span style={{ color: 'red' }}>*</span></label>
                          <Select
                            isMulti
                            options={jobTitleOptions}
                            value={selectedJobTitles}
                            onChange={setSelectedJobTitles}
                          />
                        </div>

                        <div className="form-group">
                          <label>Target Audience <span style={{ color: 'red' }}>*</span></label>
                          <Select
                            isMulti
                            options={audienceOptions}
                            value={selectedTargetAudience}
                            onChange={setSelectedTargetAudience}
                          />
                        </div>

                      </div>

                      <div className="form-row">

                        <div className="form-group">
                          <label>Country <span style={{ color: 'red' }}>*</span></label>
                          <Select
                            isMulti
                            options={countryOptions}
                            value={countryCode}
                            onChange={setCountryCode}
                          />
                        </div>

                        <div className="form-group">
                          <label>Industry <span style={{ color: 'red' }}>*</span></label>
                          <Select
                            isMulti
                            options={industryOptions}
                            value={selectedIndustry}
                            onChange={setSelectedIndustry}
                          />
                        </div>

                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>Language</label>
                          <Select
                            options={languageOptions}
                            value={selectedLanguage}
                            onChange={setSelectedLanguage}
                            placeholder="Select language (default: English)"
                            isClearable={false}
                          />
                          <small style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '5px', display: 'block' }}>
                            All AI-generated content will be in the selected language
                          </small>
                        </div>
                      </div>

                      {/* Business fields - Only show for Page AccountType */}
                      {accountType === 'Page' && (
                        <>
                          <div className="form-row">
                            <div className="form-group">
                              <label>Business Name <span style={{ color: 'red' }}>*</span></label>
                              <input
                                type="text"
                                placeholder="Enter your business name"
                                value={businessName}
                                onChange={(e) => setBusinessName(e.target.value)}
                                style={{
                                  backgroundColor: "#fff",
                                  border: "1px solid #ced4da",
                                  borderRadius: ".25rem",
                                  color: "#495057",
                                  width: "100%",
                                  padding: "0.375rem 0.75rem",
                                  marginTop: 10
                                }}
                              />
                            </div>

                            <div className="form-group">
                              <label>Brand Tone</label>
                              <Select
                                options={brandToneOptions}
                                value={brandTone}
                                onChange={setBrandTone}
                                placeholder="Select brand tone"
                                isClearable
                              />
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group">
                              <label>Primary Services</label>
                              <Select
                                isMulti
                                options={primaryServicesOptions}
                                value={primaryServices}
                                onChange={(selectedOptions) => setPrimaryServices(selectedOptions || [])}
                                placeholder="Select services..."
                                isClearable
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    marginTop: 10,
                                    minHeight: 38
                                  })
                                }}
                              />
                            </div>

                            <div className="form-group">
                              <label>Writing Style</label>
                              <Select
                                options={writingStyleOptions}
                                value={writingStyle}
                                onChange={setWritingStyle}
                                placeholder="Select writing style"
                                isClearable
                              />
                            </div>
                          </div>

                          <div className="form-row">
                            <div className="form-group">
                              <label>Business Description <span style={{ color: 'red' }}>*</span></label>
                              <textarea
                                placeholder="Describe your business, what you do, and your core values..."
                                value={businessDescription}
                                onChange={(e) => setBusinessDescription(e.target.value)}
                                rows={4}
                                style={{
                                  backgroundColor: "#fff",
                                  border: "1px solid #ced4da",
                                  borderRadius: ".25rem",
                                  color: "#495057",
                                  width: "100%",
                                  resize: "vertical",
                                  marginTop: 10
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="form-row">
                        <div className="form-group">
                          <label>Goal <span style={{ color: 'red' }}>*</span></label>

                          <textarea
                            placeholder="What topics you would like to post on........e.g., AI trends, startup news, productivity tips"
                            value={goal}
                            onChange={handleGoalChange}
                            rows={8} // Adjust as necessary
                            style={{
                              backgroundColor: "#fff",
                              border: "1px solid #ced4da",
                              borderRadius: ".25rem",
                              color: "#495057",
                              width: "100%", // Full width of the parent container
                              resize: "vertical", // Optional, to allow vertical resizing
                              marginTop: 10
                            }}
                          />
                        </div>

                      </div>
                      <div className="form-group">
                        <button style={{ float: "right" }} type="button" onClick={handlesaveJobTitleandTarget} className="btn btn-primary mt-3">
                          Save
                        </button></div>
                      {/* <div className="form-group">
                        <button style={{ float: "right" }} type="button" onClick={generatePrompts} className="btn btn-primary mt-3">
                          Generate AI Prompts
                        </button></div> */}
                    </div>
                  </div>
                </div>
              </div>
              <section className="mt-3">
                <div className="row">

                  {/* <div className="accordion accordion-flush" id="accordionFlushExample8">
                    <div className="accordion-item">
                      <div className="accordion-header shadow-sm" id="flush-heading">
                        <button
                          id="aiAccordionButton"
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseEight"
                          aria-expanded="false"
                          aria-controls="flush-collapseEight"
                        >
                          <h5>AI Suggestion Prompts</h5>
                        </button>
                      </div>
                      <div
                        id="flush-collapseEight"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingEight"
                        data-bs-parent="#accordionFlushExample8"
                      >
                        <div className="accordion-body">
                          <div className="row mt-4">

                            <div>
                              <p style={{ fontWeight: 'bold', color: '#2e3192' }}>AI-generated prompts based on your input are listed here—edit or save to personalize your post ideas.</p>
                            </div>

                            {aiSuggestions.map((suggestion, index) => (
                              <div key={index} className="col-md-6 col-lg-4 mb-4">
                                <div className="card" style={{ height: 250 }}>
                                  <div className="card-body schedule-card">
                                    <textarea
                                      placeholder={`Prompt ${index + 1}`}
                                      value={suggestion.AIPromptData}
                                      onChange={(e) => {
                                        const updatedSuggestions = [...aiSuggestions];
                                        updatedSuggestions[index].AIPromptData = e.target.value;
                                        setAiSuggestions(updatedSuggestions);
                                      }}
                                      disabled={editingIndex !== index}
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '0px',
                                        resize: 'none',
                                        background: 'none',
                                        border: 'none',
                                      }}
                                    />
                                  </div>
                                  <div className="card-footer">
                                    <div className="d-flex justify-content-between">
                                      {editingIndex === index ? (
                                        <button type="button" onClick={() => handleSave1(index)} className="btn btn-success">
                                          <FontAwesomeIcon icon={faSave} />
                                        </button>
                                      ) : (
                                        <button type="button" onClick={() => handleEdit1(index)} className="btn btn-primary">
                                          <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                      )}
                                      <button type="button" onClick={() => handleDelete1(index)} className="btn btn-danger">
                                        <FontAwesomeIcon icon={faTrash} />
                                      </button>
                                      {showSaveButton && <button
                                        type="button"
                                        onClick={() => handleSaveToPromptTable(index)}
                                        className="btn btn-success"
                                      >
                                        <FontAwesomeIcon icon={faSave} /> 
                                      </button>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                            {aiSuggestions?.length === 0 && (
                              <div className="col-12 text-center mt-4">
                                <em>No AI suggestions yet. Add a goal and click Generate in User Preferences section.</em>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="accordion accordion-flush" id="accordionFlushExample6">
                    <div className="accordion-item">
                      <div className="accordion-header  shadow-sm" id="flush-heading">
                        <button
                          id="savedPromptsAccordionButton"
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseSix"
                          aria-expanded="false"
                          aria-controls="flush-collapseSix"
                        >
                          <h5>Post Prompts</h5>
                        </button>
                      </div>
                      <div
                        id="flush-collapseSix"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingSix"
                        data-bs-parent="#accordionFlushExample6"
                      >
                        <div className="accordion-body">
                          <div className="row">
                            <div className='d-flex justify-content-between'>
                              <div>
                                <p style={{ color: '#2e3192', fontWeight: 'bold' }}>Saved Prompts include AI-generated suggestions and your manually added prompts. You can use them directly when scheduling a post through Post Tools.</p>
                              </div>
                              <div >
                                <button
                                  type="button"
                                  onClick={addPromptField}
                                  style={{ margin: '10px 0' }}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                            {promptData.map((prompt, index) => (
                              <div key={index} className="col-md-6 col-lg-4 mb-4">
                                <div className="card" style={{ height: 250 }}>
                                  <div className="card-body schedule-card">
                                    <textarea
                                      placeholder={`Prompt ${index + 1}`}
                                      value={prompt.text}
                                      onChange={(e) => handlePromptChange(index, e.target.value)}
                                      disabled={!prompt.isEditing}
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '0px',
                                        resize: 'none',
                                        background: 'none',
                                        border: 'none',
                                      }}
                                    />
                                  </div>
                                  <div className="card-footer">
                                    <div className="d-flex justify-content-between">
                                      {prompt.isEditing ? (
                                        <>
                                          <button
                                            type="button"
                                            onClick={() => handleSave(index)}
                                            className="btn btn-success"
                                            disabled={loadingSubmit}
                                          >
                                            <FontAwesomeIcon icon={faSave} />
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => handleDelete(index)}
                                            className="btn btn-danger"
                                          >
                                            <FontAwesomeIcon icon={faTrash} />
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            type="button"
                                            onClick={() => handleEdit(index)}
                                            className="btn btn-primary"
                                          >
                                            <FontAwesomeIcon icon={faEdit} />
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => handleDelete(index)}
                                            className="btn btn-danger"
                                          >
                                            <FontAwesomeIcon icon={faTrash} />
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                                         </div>
                   </div>
 
                 </div>
              </section>
            </div>
          </div>

        )}
        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} centered>
          <Modal.Body className="text-center">
            Do you want to schedule post on this selected holiday?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={() => handleHolidayChange()}>
              Schedule Post
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </SideNavbar>
  );
};

export default UserForm;